import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import Configuration from './Configuration';
import BankPayouts from './BankPayouts';


export default class SettingsLayout extends React.Component {
  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="groups-app" match={this.props.match}>
        <Route
          exact
          path="/settings"
          render={() => <Configuration {...this.props} />}
        />
        <Route
          exact
          path="/settings/configuration"
          render={() => <Configuration {...this.props} />}
        />
        <Route
          exact
          path="/settings/bank-payouts"
          render={() => <BankPayouts />}
        />
      </RenderContent>
    );
  }
}
